module.exports = __webpack_public_path__ + "static/coding_interactions_keyboard_3_do-7602bc53840ff16e38570c85ce26a43a.png";